import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Modal from 'components/GeneralComponents/Modal';
import ShiftDetailComponentContainer from '../ShiftDetail/ShiftDetailComponentContainer';
import DeleteShiftComponentContainer from '../../Header/DeleteShiftComponentContainer';
import ManageApplicantModalComponentContainer from '../ManageApplicantModalComponentContainer';
import styledConfirm from '../../../../UserManagement/components/Header/styled';
import constants from '../../../constants';
import service from '../../../duck/service';

const ShiftDetailModals = forwardRef(({
    matrix,
    rangeStart,
    locationSettings,
    allUsers,
    prepareToCopyShift,
    locationId,
}, ref) => {
    const [modalState, setModalState] = useState({
        showShiftDetailModal: false,
        showDeleteShiftModal: false,
        showManageApplicantModal: false,
    });

    const [shiftToView, setShiftToView] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [userToAddShiftTo, setUserToAddShiftTo] = useState(null);
    const [shiftId, setShiftId] = useState(null);
    const [deleteShiftId, setDeleteShiftId] = useState(null);
    const [deleteShiftLocationId, setDeleteShiftLocationId] = useState(null);
    const [shouldRevokeChildCard, setShouldRevokeChildCard] = useState(false);

    const [shiftForApplicant, setShiftForApplicant] = useState(null);
    const [applicantToManage, setApplicantToManage] = useState(null);
    const [willApproveApplicant, setWillApproveApplicant] = useState(false);
    const [creationType, setCreationType] = useState(constants.ShiftCreationType.Inventory);

    const shiftSubtype = service.getShiftSubType(shiftToView);
    const isOpenShiftConfigured = locationSettings?.cfg__shift__post_open_shift === true;

    useImperativeHandle(ref, () => ({
        openShiftDetail: (shift, date, user = null, creationType = constants.ShiftCreationType.Inventory, id = null) => {
            setShiftToView(shift);
            setSelectedDate(date);
            setUserToAddShiftTo(user);
            setShiftId(id);
            setCreationType(creationType);
            setModalState(s => ({ ...s, showShiftDetailModal: true }));
        },
        prepareToDeleteShift: (scheduleId, locationId, revoke) => {
            setDeleteShiftId(scheduleId);
            setDeleteShiftLocationId(locationId);
            setShouldRevokeChildCard(revoke);
            setModalState(s => ({ ...s, showDeleteShiftModal: true }));
        },
        prepareToApproveApplicant: (shift, applicant) => {
            setShiftForApplicant(shift);
            setApplicantToManage(applicant);
            setWillApproveApplicant(true);
            setModalState(s => ({ ...s, showManageApplicantModal: true }));
        },
        prepareToDenyApplicant: (shift, applicant) => {
            setShiftForApplicant(shift);
            setApplicantToManage(applicant);
            setWillApproveApplicant(false);
            setModalState(s => ({ ...s, showManageApplicantModal: true }));
        },
        closeAllModals: () => {
            setModalState({
                showShiftDetailModal: false,
                showDeleteShiftModal: false,
                showManageApplicantModal: false,
            });
        },
    }));

    return (
        <>
            {modalState.showShiftDetailModal && (
                <Modal>
                    <ShiftDetailComponentContainer
                        shiftId={shiftId}
                        date={selectedDate}
                        cancelModal={() => setModalState(s => ({ ...s, showShiftDetailModal: false }))}
                        presentedShift={shiftToView}
                        prepareToDeleteShift={ref.current?.prepareToDeleteShift}
                        prepareToCopyShift={prepareToCopyShift}
                        prepareToApproveApplicant={ref.current?.prepareToApproveApplicant}
                        prepareToDenyApplicant={ref.current?.prepareToDenyApplicant}
                        userToAddShiftTo={userToAddShiftTo}
                        shiftMatrix={matrix}
                        weekRangeStart={rangeStart}
                        handleTooltipHide={() => { }}
                        handleTooltipShow={() => { }}
                        isOpenShiftConfigured={isOpenShiftConfigured}
                                                locationId={locationId}
                        creationType={creationType}
                      />
                </Modal>
            )}

            {modalState.showDeleteShiftModal && (
                <Modal>
                    <DeleteShiftComponentContainer
                        subtype={shiftSubtype}
                        deleteShiftId={deleteShiftId}
                        deleteShiftLocationId={deleteShiftLocationId}
                        cancelModal={() => setModalState(s => ({ ...s, showDeleteShiftModal: false }))}
                        shouldRevokeChildCard={shouldRevokeChildCard}
                    />
                </Modal>
            )}

            {modalState.showManageApplicantModal && (
                <Modal>
                    <ManageApplicantModalComponentContainer
                        cancelModal={() => setModalState(s => ({ ...s, showManageApplicantModal: false }))}
                        presentedShift={shiftForApplicant}
                        selectedApplicant={applicantToManage}
                        willApproveApplicant={willApproveApplicant}
                    />
                </Modal>
            )}

            <styledConfirm.Overlay display={modalState.showShiftDetailModal || modalState.showDeleteShiftModal ? 'block' : 'none'} />
            <styledConfirm.Overlay zindex={5} display={modalState.showManageApplicantModal ? 'block' : 'none'} />
        </>
    );
});

export default ShiftDetailModals;
